export const FREEFORM_CODE = 'FFM'
export type FreeformCode = typeof FREEFORM_CODE

export type PhoneInputSize = 'small' | 'medium'
